"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ServerSideEncryptionConfiguration_1 = require("./_ServerSideEncryptionConfiguration");
exports.PutBucketEncryptionInput = {
    type: "structure",
    required: ["Bucket", "ServerSideEncryptionConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        ServerSideEncryptionConfiguration: {
            shape: _ServerSideEncryptionConfiguration_1._ServerSideEncryptionConfiguration,
            locationName: "ServerSideEncryptionConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "ServerSideEncryptionConfiguration"
};
//# sourceMappingURL=PutBucketEncryptionInput.js.map